// 트랜지션 드래그 데이터 타입
export const TRANSITION_DRAG_TYPE = 'application/x-editor-transition';

export type TransitionType =
  | 'fade'
  | 'slide'
  | 'wipe'
  | 'flip'
  | 'clockWipe'
  | 'iris'
  | 'capsuleCover';

// 트랜지션 방향 타입
export type TransitionDirection =
  | 'from-left'
  | 'from-right'
  | 'from-top'
  | 'from-bottom';

// 방향 설정이 가능한 트랜지션 타입
export const DIRECTION_SUPPORTED_TRANSITIONS: TransitionType[] = [
  'slide',
  'wipe',
  'flip',
];

// 트랜지션 타입이 방향 설정을 지원하는지 확인
export const supportsDirection = (type: TransitionType): boolean =>
  DIRECTION_SUPPORTED_TRANSITIONS.includes(type);

// 기본 방향
export const DEFAULT_TRANSITION_DIRECTION: TransitionDirection = 'from-left';

// 사용 가능한 방향 목록
export const TRANSITION_DIRECTIONS: {
  value: TransitionDirection;
  label: string;
}[] = [
  { value: 'from-left', label: 'Left' },
  { value: 'from-right', label: 'Right' },
  { value: 'from-top', label: 'Top' },
  { value: 'from-bottom', label: 'Bottom' },
];

export interface TransitionDragData {
  type: TransitionType;
  name: string;
  direction?: TransitionDirection;
}

// 드래그 중인 트랜지션 데이터를 전역으로 저장 (dragover에서 getData 불가능하기 때문)
let currentTransitionDragData: TransitionDragData | null = null;

export const getCurrentTransitionDragData = (): TransitionDragData | null =>
  currentTransitionDragData;

export const setCurrentTransitionDragData = (
  data: TransitionDragData | null,
): void => {
  currentTransitionDragData = data;
};
